import React, {useEffect, useState} from 'react';

// custom components
import { } from '_atoms';
import { } from '_molecules';
import { } from '_organisms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

// redux
import { useSelector, useDispatch, } from 'react-redux';

// utils
import { Colors, Spacing, Typography } from '_styles';

// icons
import { AiOutlineCloseCircle } from "react-icons/ai";

// exterior libraries
import { Block, Card, ColGrid, Flex, Text, Title, Subtitle, BadgeDelta,  ToggleItem, Toggle, Metric, Badge, Col as TremorCol, BarList, Bold} from '@tremor/react';

const InformationContainer = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <Container className='mt-3'>
            <Container>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <Text><Bold>Wave Forecasting</Bold></Text>
                    <AiOutlineCloseCircle size={28} color={'grey'} style={{cursor:'pointer'}} onClick={props.close} />
                </div>
                {props.children}
            </Container>
        </Container>
    );
};

export default InformationContainer;